import React, {Suspense, useEffect} from 'react'

// ** Router Import
import Router from './router/Router'
import {useNavigate} from "react-router-dom"
import {setExpiration} from "./utility/Utils"

const App = () => {
    const navigate = useNavigate()
    let expirationInterval = false

    useEffect(() => {
        expirationInterval = setExpiration(navigate)

        return function stop() {
            clearInterval(expirationInterval)
        }
    }, [])

    useEffect(() => {
        if (expirationInterval === true) {
            //console.log("PO PLATNOSTI")
        }
    }, [expirationInterval])

    return (
        <Suspense fallback={null}>
          <Router />
        </Suspense>
      )
}

export default App
